<template>
    <div>
        <!-- <AnimatedHeader :labels="collectionsLabels">
            <AnimatedHeaderContent title="Coleções" /> -->
        <!-- </AnimatedHeader> -->
        <div class="content">
            <h1 class="text-bold text-uppercase">Collabs</h1>
            <p>
                Como materializar uma marca, um projeto, uma trajetória… Em produtos? <br />Nós
                lidamos com esse desafio há muitos anos e conhecemos os caminhos para transformar
                ideias intangíveis em produtos exclusivos e inovadores. Já foram mais de 200
                coleções entre licenciamentos de grandes marcas, campanhas de collabs com nomes
                incríveis da música e criadores de conteúdo de todo o Brasil.
            </p>
        </div>
        <div class="content mt-5 mb-5">
            <div class="d-flex culture-content">
                <div class="gradient-bar"></div>

                <div style="width: 100%">
                    <div class="flex-grid mgBottom ml-5">
                        <div class="flex-xs-12 flex-sm-6 flex-md-6 flex-lg-4">
                            <div class="secoes mt-0">
                                <div class="titulo-secoes">
                                    <h4
                                        @click="musicButton = !musicButton"
                                        class="text-uppercase d-flex flex-align-center hidden-md-up"
                                    >
                                        <span
                                            :class="
                                                musicButton
                                                    ? 'icon-chevron-up-2'
                                                    : 'icon-chevron-down-2'
                                            "
                                            class="icon-cr mr-2"
                                        ></span
                                        >Música
                                    </h4>
                                    <h4 class="text-uppercase hidden-md-down">Música</h4>
                                </div>
                                <div v-if="musicButton">
                                    <ul>
                                        <li>
                                            <a
                                                href="/alceu-valenca"
                                                class="text-uppercase withTextBold"
                                                >Alceu Valença</a
                                            >
                                        </li>
                                        <li>
                                            <a href="/chico-cesar" class="text-uppercase"
                                                >Chico César</a
                                            >
                                        </li>
                                        <li>
                                            <a href="/chico-science" class="text-uppercase"
                                                >Chico Science</a
                                            >
                                        </li>
                                        <li>
                                            <a href="/elza-soares" class="text-uppercase"
                                                >Elza Soares</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="/gilberto-gil"
                                                class="text-uppercase withTextBold"
                                                >Gilberto Gil</a
                                            >
                                        </li>
                                        <li>
                                            <a href="/lenine" class="text-uppercase">Lenine</a>
                                        </li>
                                        <li>
                                            <a
                                                href="/milton-nascimento"
                                                class="text-uppercase withTextBold"
                                                >Milton Nascimento</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="/zeca-pagodinho"
                                                class="text-uppercase withTextBold"
                                                >Zeca Pagodinho</a
                                            >
                                        </li>
                                        <li>
                                            <a href="/rt-mallone" class="text-uppercase"
                                                >RT Mallone</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="flex-xs-12 flex-sm-6 flex-md-6 flex-lg-4">
                            <div class="d-flex flex-column flex-spaced-fixed">
                                <div class="secoes">
                                    <div class="titulo-secoes">
                                        <h4
                                            @click="meioAmbienteButton = !meioAmbienteButton"
                                            class="text-uppercase d-flex flex-align-center hidden-md-up"
                                        >
                                            <span
                                                :class="
                                                    meioAmbienteButton
                                                        ? 'icon-chevron-up-2'
                                                        : 'icon-chevron-down-2'
                                                "
                                                class="icon-cr mr-2"
                                            ></span
                                            >Meio Ambiente
                                        </h4>
                                        <h4 class="text-uppercase hidden-md-down">Meio Ambiente</h4>
                                    </div>
                                    <div v-if="meioAmbienteButton">
                                        <ul>
                                            <li>
                                                <a
                                                    href="/sos-mata-atlantica"
                                                    class="text-uppercase withTextBold"
                                                    >SOS Mata Atlântica</a
                                                >
                                            </li>
                                            <li>
                                                <a href="/sos-amazonia" class="text-uppercase"
                                                    >SOS Amazônia</a
                                                >
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="secoes space">
                                    <div class="titulo-secoes">
                                        <h4
                                            @click="podcastsButton = !podcastsButton"
                                            class="text-uppercase d-flex flex-align-center hidden-md-up"
                                        >
                                            <span
                                                :class="
                                                    podcastsButton
                                                        ? 'icon-chevron-up-2'
                                                        : 'icon-chevron-down-2'
                                                "
                                                class="icon-cr mr-2"
                                            ></span
                                            >Podcasts
                                        </h4>
                                        <h4 class="text-uppercase hidden-md-down">Podcasts</h4>
                                    </div>
                                    <div v-if="podcastsButton">
                                        <ul>
                                            <li>
                                                <a href="/modus-operandi" class="text-uppercase"
                                                    >Modus Operandi</a
                                                >
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="flex-xs-12 flex-sm-6 flex-md-6 flex-lg-4">
                            <div>
                                <div class="secoes">
                                    <div class="titulo-secoes">
                                        <h4
                                            @click="cinemaButton = !cinemaButton"
                                            class="text-uppercase d-flex flex-align-center hidden-md-up"
                                        >
                                            <span
                                                :class="
                                                    cinemaButton
                                                        ? 'icon-chevron-up-2'
                                                        : 'icon-chevron-down-2'
                                                "
                                                class="icon-cr mr-2"
                                            ></span
                                            >Cinema, Séries
                                        </h4>
                                        <h4 class="text-uppercase hidden-md-down">
                                            Cinema, Séries
                                        </h4>
                                    </div>
                                    <div v-if="cinemaButton">
                                        <ul>
                                            <li>
                                                <a href="/chapolin" class="text-uppercase"
                                                    >Chapolin</a
                                                >
                                            </li>
                                            <li>
                                                <a href="/chaves" class="text-uppercase">Chaves</a>
                                            </li>
                                            <li>
                                                <a href="/tv-quase" class="text-uppercase"
                                                    >Tv quase</a
                                                >
                                            </li>

                                            <li>
                                                <a href="/irmao-do-jorel" class="text-uppercase"
                                                    >Irmão do Jorel</a
                                                >
                                            </li>
                                            <li>
                                                <a href="/mundo-bita" class="text-uppercase"
                                                    >Mundo Bita</a
                                                >
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="flex-grid mgBottom ml-5">
                        <div class="flex-xs-12 flex-sm-6 flex-md-6 flex-lg-4">
                            <div class="secoes">
                                <div class="titulo-secoes">
                                    <h4
                                        @click="artistaButton = !artistaButton"
                                        class="text-uppercase d-flex flex-align-center hidden-xs-up"
                                    >
                                        <span
                                            :class="
                                                artistaButton
                                                    ? 'icon-chevron-up-2'
                                                    : 'icon-chevron-down-2'
                                            "
                                            class="icon-cr mr-2"
                                        ></span
                                        >Artista
                                    </h4>
                                    <h4 class="text-uppercase hidden-xs-down">Artista</h4>
                                </div>
                                <div v-if="artistaButton">
                                    <ul>
                                        <li>
                                            <a
                                                href="/flavio-colin"
                                                class="text-uppercase withTextBold"
                                                >Flávio Colin</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="/frida-kahlo"
                                                class="text-uppercase withTextBold"
                                                >Frida Kahlo</a
                                            >
                                        </li>
                                        <li>
                                            <a href="/laerte" class="text-uppercase withTextBold"
                                                >Laerte</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                href="/tarsila-do-amaral"
                                                class="text-uppercase withTextBold"
                                                >Tarsila do Amaral</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="flex-xs-12 flex-sm-6 flex-md-6 flex-lg-4">
                            <div class="secoes">
                                <div class="titulo-secoes">
                                    <h4
                                        @click="timesButton = !timesButton"
                                        class="text-uppercase d-flex flex-align-center hidden-md-up"
                                    >
                                        <span
                                            :class="
                                                timesButton
                                                    ? 'icon-chevron-up-2'
                                                    : 'icon-chevron-down-2'
                                            "
                                            class="icon-cr mr-2"
                                        ></span
                                        >Times
                                    </h4>
                                    <h4 class="text-uppercase hidden-md-down">Times</h4>
                                </div>
                                <div v-if="timesButton">
                                    <ul>
                                        <li>
                                            <a href="/crvasco" class="text-uppercase"
                                                >Vasco da Gama</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="content">
            <div class="d-flex mt-5 w-full">
                <ul
                    id="img-list"
                    style="flex: 100%"
                    class="carousel-stores-img horizontal-list no-scrollbar"
                    @scroll="scrollEvent = $event"
                >
                    <a v-for="image in images">
                        <div>
                            <img class="img-carousel" :alt="image.alt" :src="image.src" />
                        </div>
                    </a>
                </ul>
            </div>
            <HorizontalScrollbar
                :scroll-event="scrollEvent"
                :button-height="110"
                :id-list="'img-list'"
            />
        </div>

        <!--        <div v-if="requests > 0" class="content mt-4 delay-show" style="min-height: 100vh">-->
        <!--            <div class="mx-auto mt-4">-->
        <!--                <Spinner />-->
        <!--            </div>-->
        <!--        </div>-->
        <!--        <div v-else class="medium-content mt-4">-->
        <!--            &lt;!&ndash; <template v-for="(collection, index) in collections"> &ndash;&gt;-->
        <!--            &lt;!&ndash; <hr v-if="index > 0" /> &ndash;&gt;-->
        <!--            &lt;!&ndash; <Collection :collection="collection" class="mt-5 mb-3" /> &ndash;&gt;-->
        <!--            &lt;!&ndash; </template> &ndash;&gt;-->
        <!--        </div>-->
    </div>
</template>

<script>
    import { partnerService } from '../../../../../submodules/src/service/resource';
    import Collection from './Collection';
    import Spinner from '../../../../../submodules/src/components/feedback/spinner/Spinner.vue';
    import AnimatedHeader from '../common/AnimatedHeader';
    import AnimatedHeaderContent from '../common/AnimatedHeaderContent';
    import HorizontalScrollbar from '../common/container/HorizontalScrollbar.vue';

    export default {
        name: 'CollectionsPage',

        components: {
            AnimatedHeaderContent,
            Spinner,
            AnimatedHeader,
            Collection,
            HorizontalScrollbar,
        },

        data() {
            return {
                requests: 0,
                collections: null,
                images: [
                    {
                        src: 'https://chico-rei.imgix.net/images/site/novo_layout_chico/milton-nascimento.png?auto=compress,format&q=65',
                        alt: '',
                    }, // todo
                    {
                        src: 'https://chico-rei.imgix.net/images/site/novo_layout_chico/zeca-pagodinho.png?auto=compress,format&q=65',
                        alt: '',
                    }, // todo
                ],
                scrollEvent: null,
                musicButton: true,
                meioAmbienteButton: true,
                podcastsButton: true,
                cinemaButton: true,
                marcasButton: true,
                artistaButton: true,
                timesButton: true,
            };
        },

        created() {
            this.fetchCollections();
        },

        computed: {
            collectionsLabels() {
                return this.collections ? this.collections.map((a) => a.name) : [];
            },
        },

        methods: {
            fetchCollections() {
                this.requests++;
                partnerService
                    .query({
                        partner_type_id: 1,
                        // include: ['products'],
                        // scopes: ['filterHasLogo'],
                    }) // todo sort by published
                    .then(
                        (response) =>
                            (this.collections = response.data.filter(
                                (c) => c.products.data.length >= 6
                            ))
                    )
                    .catch(() => (this.errorLoading = true))
                    .then(() => this.requests--);
            },
        },
    };
</script>
